export default __webpack_public_path__ + "static/media/ee2.d83aafe1.png";